import { render, staticRenderFns } from "./FaturamentoModal.vue?vue&type=template&id=b42b61c2&"
import script from "./FaturamentoModal.vue?vue&type=script&lang=js&"
export * from "./FaturamentoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FaturamentoModal.vue"
export default component.exports